<div>
  @if (hidePrevFeat) {
    <div>
      @for (feat of allFeatures; track feat) {
        <div class="row">
          <div class="col-8">
            @if (invertedImg && !isFailed) {
              <img class="tick-img" src="{{pathVal}}upArrowAnimated.gif" alt="upArrowAnimated">
            }
            @if (!invertedImg && !isFailed) {
              <img class="tick-img" src="{{pathVal}}feature_not_checked.png" alt="feature_not_checked">
            }
            @if (isFailed) {
              <img class="tick-img" src="{{pathVal}}error_red.png" alt="Error">
            }
          &nbsp;&nbsp;{{feat}} </div>
          <div class="col-4"><span> ({{initialCount}} out of {{outOfCount}})</span></div>
        </div>
      }
    </div>
  }


  @if (!hidePrevFeat) {
    <div>
      @for (feat of combineAllFeat; track feat) {
        <div class="row">
          @if (feat.flag === 'green') {
            <div class="col-8"><img class="tick-img" src="{{pathVal}}check_circle.png" alt="Success">&nbsp;&nbsp;{{feat.name}}</div>
            }@if (feat.flag === 'green') {
            <div class="col-4"><span> ({{outOfCount}} out of {{outOfCount}})</span></div>
          }
          @if (feat.flag === 'orange') {
            <div class="col-8"><img class="tick-img" src="{{pathVal}}caution_orange.png" alt="Caution">&nbsp;&nbsp;{{feat.name}}</div>
            }@if (feat.flag === 'orange') {
            <div class="col-4"><span> ({{initialCount}} out of {{outOfCount}})</span></div>
          }
          @if (feat.flag === 'red') {
            <div class="col-8"><img class="tick-img" src="{{pathVal}}error_red.png" alt="Error">&nbsp;&nbsp;{{feat.name}}</div>
            }@if (feat.flag === 'red') {
            <div class="col-4"><span> ({{initialCount}} out of {{outOfCount}})</span></div>
          }
        </div>
      }
    </div>
  }
</div>
@if (customerLoader) {
  <img src="{{pathVal}}dash-spinner.gif" class= "dash-border text-secondary custom-spinner" alt="dash-spinner">
}
